const TZ = "America/Argentina/Buenos_Aires";

const TZ_OPTIONS = {
  timeZone: TZ,
  hour12: false,
};

// Partes explícitas: sin esto, el locale es-AR usa ancho preferido (d/m/yyyy)
// y pierde el cero a la izquierda de día y mes.
const PARTS_OPTIONS = {
  timeZone: TZ,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
};

function toDate(value) {
  if (!value) return null;

  const date = new Date(value);

  return isNaN(date.getTime()) ? null : date;
}

/**
 * Formatea una fecha en string al locale argentino.
 * Retorna null si el valor es nulo, indefinido o resulta en una fecha inválida.
 *
 * @param {string|null|undefined} dateString
 * @returns {string|null}
 */
export function formatArgDate(dateString) {
  const date = toDate(dateString);

  if (!date) return null;

  return date.toLocaleString("es-AR", TZ_OPTIONS);
}

/**
 * Formatea una fecha/hora al locale argentino con día, mes, hora, minuto y
 * segundo de ancho fijo (2 dígitos, 24 horas), y devuelve un texto de reemplazo
 * cuando el valor es nulo, indefinido o resulta en una fecha inválida.
 *
 * @param {string|null|undefined} value
 * @param {string|null} fallback
 * @returns {string|null}
 */
export function formatFechaHora(value, fallback = null) {
  const date = toDate(value);

  if (!date) return fallback;

  return date.toLocaleString("es-AR", PARTS_OPTIONS);
}
